module.exports = __webpack_public_path__ + "img/1.51b14650.jpg";